import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import useResultProvider from 'dataProvider/hooks/useResultProvider';
import { LoadingPlaceholder, Limiter } from 'components';
import { getPlace } from 'dataProvider';
import './style.scss';
import { SUBTYPES, TYPES } from 'envs';
import { customAcronym, customColor, getSite } from '../../constants';

export default function BarSeats({
  place,
  resultOrigin,
  year,
  type,
  elSubtype,
  electionNumber,
  site
}) {
  const [placeToShow, setPlaceToShow] = useState();

  // Porcentaje limite que sirve para crear la leyenda de partidos del componente
  const LIMIT_LEGEND = 6.5;

  useEffect(() => {
    getPlace({ filter: `sortby=main&size=1&addid=${place}`, type }).then(
      data => {
        setPlaceToShow(data.content[0].name);
      }
    );
  }, [place]);

  const { result: dataResult } = useResultProvider({
    active: resultOrigin.primary?.active,
    year,
    type,
    subtype: elSubtype,
    electionPlace: place,
    electionNumber,
    placeId: place,
    details: false,
    site
  });

  const { result: dataResultInsular } = useResultProvider({
    active: resultOrigin.primary?.active,
    year,
    type,
    subtype: SUBTYPES.INSULAR,
    electionPlace: place,
    electionNumber,
    placeId: place,
    details: false,
    site
  });

  if (!Object.keys(dataResult).length > 0) {
    return <LoadingPlaceholder />;
  }

  const { partiesResult, placeId, currentCountPercent } = dataResult;
  const { currentCountPercent: currentCountPercentInsular } = dataResultInsular;
  const filterData = partiesResult?.filter(current => current.seats >= 1);
  const { totalSeat } = filterData?.reduce(
    (tot, current) => {
      // eslint-disable-next-line no-param-reassign
      tot.totalSeat += current.seats;
      return tot;
    },
    { totalSeat: 0 }
  ) || { totalSeat: 0 };

  // if (!partiesResult || !placeId) {
  //   return null;
  // }
  return (
    <div className="BarSeats">
      <div className="BarSeats-header">
        <h3 className="BarSeats-place">{placeToShow}</h3>
        <span className="BarSeats-scrutiny">
          Escrutinio:{' '}
          <strong>
            {' '}
            {place === 'R05'
              ? currentCountPercentInsular
              : currentCountPercent || '-'}
            %
          </strong>
        </span>
      </div>
      <div className="BarSeats-wrapper">
        <span className="BarSeats-totalSeats">
          {type === TYPES.MUNICIPAL ? 'Total concejales:' : 'Total escaños:'}{' '}
          <strong>{totalSeat}</strong>
        </span>
        <div className="BarSeats-block">
          <Limiter />
          {filterData?.map((element, index) => {
            const percentParty = (100 / totalSeat) * element.seats;

            return (
              <div
                className="BarSeats-party"
                style={{
                  width: `${(100 / totalSeat) * element.seats}%`
                }}
                // eslint-disable-next-line react/no-array-index-key
                key={`BarSeats-party-${index}`}
              >
                <div
                  key={element.placeId}
                  className="BarSeats-color"
                  style={{
                    backgroundColor: element.partyColor
                  }}
                >
                  <p className="BarSeats-seats">{element.seats}</p>
                </div>
                <abbr
                  className={
                    percentParty >= LIMIT_LEGEND
                      ? 'BarSeats-acronym'
                      : 'BarSeats-acronym BarSeats-acronym--hidden'
                  }
                  title={element.name}
                >
                  {customAcronym(element, getSite())}
                </abbr>
              </div>
            );
          })}
        </div>
        <p className="BarSeats-majority">
          Mayoría absoluta: {parseInt(totalSeat / 2, 0) + 1}
        </p>
        <ul className="BarSeats-leyend">
          {filterData?.map((element, index) => {
            const percentParty = (100 / totalSeat) * element.seats;
            return (
              percentParty <= LIMIT_LEGEND && (
                <li
                  className="BarSeats-leyend-item"
                  // eslint-disable-next-line react/no-array-index-key
                  key={`BarSeats-leyend-item-${index}`}
                >
                  <span
                    className="BarSeats-leyend-color"
                    style={{
                      backgroundColor: customColor(element, getSite())
                    }}
                  />
                  <abbr className="BarSeats-acronym" title={element.name}>
                    {customAcronym(element, getSite())}
                  </abbr>
                </li>
              )
            );
          })}
        </ul>
      </div>
    </div>
  );
}

BarSeats.propTypes = {
  place: PropTypes.string.isRequired,
  resultOrigin: PropTypes.shape({
    primary: PropTypes.shape({
      active: PropTypes.bool.isRequired
    }).isRequired
  }).isRequired,
  year: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  elSubtype: PropTypes.string.isRequired,
  electionNumber: PropTypes.string.isRequired,
  site: PropTypes.string.isRequired
};
